import { createSlice } from '@reduxjs/toolkit';

import { ModalsSliceState } from './modalsSliceTypes';

import { RootState } from 'rootReducer';
import MatchEvent from 'interfaces/matchEvent';

const initialState: ModalsSliceState = {
  showDeleteEventModal: false,
  showMatchEndedModal: false,
  showHalfTimeModal: false,
  showStartMatchModal: false,
  showSecondHalfModal: false,
  showFirstHalfExtraTimeModal: false,
  showHalfTimeExtraTimeModal: false,
  showSecondHalfExtraTimeModal: false,
  showPenaltiesModal: false,
  showMatchNotStartedModal: false,
  showResetAndReloadModal: false,
  showInfoModal: false,
  showConsiderReloadModal: false,
  deleteEvent: null,
  deleteAssistEvent: null,
  deleteSubstituteEvent: null,
  deleteFouledEvent: null,
  deleteOffenceEvent: null,
  deletePenaltyMissEvent: null,
  deletePenaltyGoalEvent: null,
  deletePenaltySaveEvent: null,
};

export const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    openDeleteEventModal: (state, action) => {
      state.showDeleteEventModal = true;
      state.deleteEvent = action.payload.event;
      state.deleteAssistEvent = action.payload.assistEvent;
      state.deleteSubstituteEvent = action.payload.substituteEvent;
      state.deleteFouledEvent = action.payload.fouledEvent;
      state.deleteOffenceEvent = action.payload.offenceEvent;
      state.deletePenaltyMissEvent = action.payload.penaltyMissEvent;
      state.deletePenaltyGoalEvent = action.payload.penaltyGoalEvent;
      state.deletePenaltySaveEvent = action.payload.penaltySaveMatchEvent;
    },
    closeDeleteEventModal: (state) => {
      state.showDeleteEventModal = false;
    },
    setMatchEndedModal: (state, action) => {
      state.showMatchEndedModal = action.payload;
    },
    setPauseMatchModal: (state, action) => {
      state.showHalfTimeModal = action.payload;
    },
    setStartMatchModal: (state, action) => {
      state.showStartMatchModal = action.payload;
    },
    setMatchNotStartedModal: (state, action) => {
      state.showMatchNotStartedModal = action.payload;
    },
    setSecondHalfModal: (state, action) => {
      state.showSecondHalfModal = action.payload;
    },
    setFirstHalfExtraTimeModal: (state, action) => {
      state.showFirstHalfExtraTimeModal = action.payload;
    },
    setHalfTimeExtraTimeModal: (state, action) => {
      state.showHalfTimeExtraTimeModal = action.payload;
    },
    setSecondHalfExtraTimeModal: (state, action) => {
      state.showSecondHalfExtraTimeModal = action.payload;
    },
    setPenaltiesModal: (state, action) => {
      state.showPenaltiesModal = action.payload;
    },
    setResetAndReloadModal: (state, action) => {
      state.showResetAndReloadModal = action.payload;
    },
    setInfoModal: (state, action) => {
      state.showInfoModal = action.payload;
    },
    setConsiderReloadModal: (state, action) => {
      state.showConsiderReloadModal = action.payload;
    },
  },
});

export const selectShowDeleteEventModal = (state: RootState): boolean => state.modals.showDeleteEventModal;
export const selectShowMatchEndedModal = (state: RootState): boolean => state.modals.showMatchEndedModal;
export const selectShowPauseMatchModal = (state: RootState): boolean => state.modals.showHalfTimeModal;
export const selectShowStartMatchModal = (state: RootState): boolean => state.modals.showStartMatchModal;
export const selectShowMatchNotStartedModal = (state: RootState): boolean => state.modals.showMatchNotStartedModal;
export const selectShowSecondHalfModal = (state: RootState): boolean => state.modals.showSecondHalfModal;
export const selectShowFirstHalfExtraTimeModal = (state: RootState): boolean =>
  state.modals.showFirstHalfExtraTimeModal;
export const selectShowHalfTimeExtraTimeModal = (state: RootState): boolean => state.modals.showHalfTimeExtraTimeModal;
export const selectShowSecondHalfExtraTimeModal = (state: RootState): boolean =>
  state.modals.showSecondHalfExtraTimeModal;
export const selectShowPenaltiesModal = (state: RootState): boolean => state.modals.showPenaltiesModal;
export const selectShowResetAndReloadModal = (state: RootState): boolean => state.modals.showResetAndReloadModal;
export const selectInfoModal = (state: RootState): boolean => state.modals.showInfoModal;
export const selectConsiderReloadModal = (state: RootState): boolean => state.modals.showConsiderReloadModal;

export const selectDeleteEvent = (state: RootState): MatchEvent | null => state.modals.deleteEvent;
export const selectDeleteAssistEvent = (state: RootState): MatchEvent | null | undefined =>
  state.modals.deleteAssistEvent;
export const selectDeleteSubstituteEvent = (state: RootState): MatchEvent | null | undefined =>
  state.modals.deleteSubstituteEvent;
export const selectDeleteFouledEvent = (state: RootState): MatchEvent | null | undefined =>
  state.modals.deleteFouledEvent;
export const selectDeleteOffenceEvent = (state: RootState): MatchEvent | null | undefined =>
  state.modals.deleteOffenceEvent;
export const selectDeletePenaltyMissEvent = (state: RootState): MatchEvent | null | undefined =>
  state.modals.deletePenaltyMissEvent;
export const selectDeletePenaltyGoalEvent = (state: RootState): MatchEvent | null | undefined =>
  state.modals.deletePenaltyGoalEvent;
export const selectDeletePenaltySaveEvent = (state: RootState): MatchEvent | null | undefined =>
  state.modals.deletePenaltySaveEvent;

export const modalsActions = modalsSlice.actions;

export default modalsSlice.reducer;
